export default "/images/patinaje.jpg?f7d71ed25540d7aa149336aaec986643";